<template>
  <div class="background-music" v-if="presentation && presentation.audioLink">
    <audio
      :src="presentation.audioLink.url"
      controls
      preload="auto"
      :loop="true"
      ref="audio-background-music"
      @pause="eventPause"
      @play="eventPlay"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import QuizStatuses from '@/constant/QuizStatuses'
import AudioControlInterfaceMixin from '@/components/presentations/interface/AudioControl.interface.mixin'

const audioRef = 'audio-background-music'

export default {
  name: 'BackgroundMusic',
  mixins: [AudioControlInterfaceMixin],
  data() {
    return {
      isPlayingBeforeNextSlide: true,
      isPlaying: false,
      isAudioPlayingBeforeSlideSpinner: false,
      autoPause: false,
      autoPlay: false,
      isManualPause: false,
    }
  },
  computed: {
    ...mapGetters(['isPresenting']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
    quizStatus() {
      return this.slideActive.quizStatus
    },
    isQuizLobbyScreen() {
      const { type, quizStatus } = this.slideActive
      return type === 'pickAnswer' && quizStatus === QuizStatuses.LOBBY_SCREEN
    },
    hasSlideMusic() {
      return !this.isQuizLobbyScreen && this.slideActive.audioLink
    },
  },
  watch: {
    slideActive(value, oldValue) {
      if (!value || !oldValue || !value.id) {
        return
      }
      if (value.id === oldValue.id) {
        return
      }
      if (!this.isPresenting) {
        this.pauseMusic()
        return
      }

      if (this.getHasSlideMusic(value)) {
        this.pauseMusic()
        return
      }

      if (!this.handleNextSlideSpinner(value, oldValue)) {
        return
      }

      if (!this.isManualPause) {
        this.playMusic()
      }
    },
    isPresenting(value) {
      if (!value) {
        this.isManualPause = false
        this.pauseMusic()
        return
      }
      if (this.hasSlideMusic) {
        this.pauseMusic()
        return
      }
      if (!this.handleNextSlideSpinner({}, {})) {
        return
      }
      setTimeout(() => {
        this.playMusic()
      }, 1000)
    },
    quizStatus(value) {
      // Nếu quiz có SlideMusic thì sẽ pause BackgroundMusic khi chuyển tới màn quiz
      if ((value !== QuizStatuses.LOBBY_SCREEN) && this.hasSlideMusic) {
        this.autoPause = true
        this.pauseMusic()
        return
      }
      setTimeout(() => {
        if (this.isPresenting && !this.isManualPause && this.slideActive.type === 'pickAnswer') {
          this.playMusic()
        }
      })
    },
  },
  destroyed() {
    this.pauseMusic()
  },
  methods: {
    togglePlay(isPlaying) {
      if (isPlaying) {
        this.playMusic()
      } else {
        this.pauseMusic()
      }
    },
    getAudioSource() {
      return this.$refs[audioRef]
    },
    playMusic() {
      if (this.$refs[audioRef]) {
        this.autoPlay = true
        this.$refs[audioRef].play()
      }
    },
    pauseMusic() {
      if (this.$refs[audioRef]) {
        this.autoPause = true
        this.$refs[audioRef].pause()

        // đẩy vào callstack, sẽ chạy sau eventPause
        setTimeout(() => {
          this.autoPause = false
        })
      }
    },
    getHasSlideMusic(slide) {
      if (!slide || !slide.id) {
        return false
      }
      const { type, quizStatus } = slide
      const isQuizLobbyScreen = type === 'pickAnswer' && quizStatus === QuizStatuses.LOBBY_SCREEN
      return !isQuizLobbyScreen && slide.audioLink
    },
    eventPause() {
      this.isPlaying = false
      if (!this.autoPause) {
        this.isManualPause = true
      }
      this.autoPause = false
    },
    eventPlay() {
      this.isPlaying = true
      if (!this.autoPlay) {
        this.isManualPause = false
      }
      this.autoPlay = false
    },
    handleNextSlideSpinner(value, oldValue) {
      if (this.slideActive.type === 'spinnerWheel') {
        this.isAudioPlayingBeforeSlideSpinner = this.isPlaying
        this.pauseMusic()
        return false
      }
      // slide trước là spinnerWhell thì sẽ play nếu trước đó đang play
      if (oldValue.type === 'spinnerWheel') {
        if (this.isAudioPlayingBeforeSlideSpinner) {
          this.playMusic()
        }
      }
      return true
    },
  },
}
</script>

<style scoped>

</style>
